module.exports = __webpack_public_path__ + "img/4_32.545226f1.png";